// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { NotifyIntegratorDTO } from '../models';
import { OrganizationUserDTO } from '../models';
/**
 * OrganizationUsersApi - axios parameter creator
 * @export
 */
export const OrganizationUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Grant roles to an organization user
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantRoles(userId: string, organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling grantRoles.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling grantRoles.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/users/{userId}/grant-roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the API key and user id of an organization user to an integrator
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {NotifyIntegratorDTO} notifyIntegratorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyIntegrator(userId: string, organizationId: string, notifyIntegratorDTO: NotifyIntegratorDTO, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling notifyIntegrator.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling notifyIntegrator.');
            }
            // verify required parameter 'notifyIntegratorDTO' is not null or undefined
            if (notifyIntegratorDTO === null || notifyIntegratorDTO === undefined) {
                throw new RequiredError('notifyIntegratorDTO','Required parameter notifyIntegratorDTO was null or undefined when calling notifyIntegrator.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/users/{userId}/notify-integrator`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"NotifyIntegratorDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(notifyIntegratorDTO !== undefined ? notifyIntegratorDTO : {}) : (notifyIntegratorDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke roles from an organization user
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeRoles(userId: string, organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling revokeRoles.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling revokeRoles.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/users/{userId}/revoke-roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationUsersApi - functional programming interface
 * @export
 */
export const OrganizationUsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Grant roles to an organization user
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantRoles(userId: string, organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationUsersApiAxiosParamCreator(configuration).grantRoles(userId, organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send the API key and user id of an organization user to an integrator
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {NotifyIntegratorDTO} notifyIntegratorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyIntegrator(userId: string, organizationId: string, notifyIntegratorDTO: NotifyIntegratorDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationUsersApiAxiosParamCreator(configuration).notifyIntegrator(userId, organizationId, notifyIntegratorDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Revoke roles from an organization user
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeRoles(userId: string, organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUserDTO> {
            const localVarAxiosArgs = OrganizationUsersApiAxiosParamCreator(configuration).revokeRoles(userId, organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrganizationUsersApi - factory interface
 * @export
 */
export const OrganizationUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Grant roles to an organization user
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantRoles(userId: string, organizationId: string, options?: any) {
            return OrganizationUsersApiFp(configuration).grantRoles(userId, organizationId, options)(axios, basePath);
        },
        /**
         * Send the API key and user id of an organization user to an integrator
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {NotifyIntegratorDTO} notifyIntegratorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyIntegrator(userId: string, organizationId: string, notifyIntegratorDTO: NotifyIntegratorDTO, options?: any) {
            return OrganizationUsersApiFp(configuration).notifyIntegrator(userId, organizationId, notifyIntegratorDTO, options)(axios, basePath);
        },
        /**
         * Revoke roles from an organization user
         * @param {string} userId User id
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeRoles(userId: string, organizationId: string, options?: any) {
            return OrganizationUsersApiFp(configuration).revokeRoles(userId, organizationId, options)(axios, basePath);
        },
    };
};

/**
 * OrganizationUsersApi - interface
 * @export
 * @interface OrganizationUsersApi
 */
export interface OrganizationUsersApiInterface {
    /**
     * Grant roles to an organization user
     * @param {string} userId User id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    grantRoles(userId: string, organizationId: string, options?: any): AxiosPromise<object>;

    /**
     * Send the API key and user id of an organization user to an integrator
     * @param {string} userId User id
     * @param {string} organizationId Organization id
     * @param {NotifyIntegratorDTO} notifyIntegratorDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    notifyIntegrator(userId: string, organizationId: string, notifyIntegratorDTO: NotifyIntegratorDTO, options?: any): AxiosPromise<object>;

    /**
     * Revoke roles from an organization user
     * @param {string} userId User id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    revokeRoles(userId: string, organizationId: string, options?: any): AxiosPromise<OrganizationUserDTO>;

}

/**
 * OrganizationUsersApi - object-oriented interface
 * @export
 * @class OrganizationUsersApi
 * @extends {BaseAPI}
 */
export class OrganizationUsersApi extends BaseAPI implements OrganizationUsersApiInterface {
    /**
     * Grant roles to an organization user
     * @param {string} userId User id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public grantRoles(userId: string, organizationId: string, options?: any) {
        return OrganizationUsersApiFp(this.configuration).grantRoles(userId, organizationId, options)(this.axios, this.basePath);
    }

    /**
     * Send the API key and user id of an organization user to an integrator
     * @param {string} userId User id
     * @param {string} organizationId Organization id
     * @param {NotifyIntegratorDTO} notifyIntegratorDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public notifyIntegrator(userId: string, organizationId: string, notifyIntegratorDTO: NotifyIntegratorDTO, options?: any) {
        return OrganizationUsersApiFp(this.configuration).notifyIntegrator(userId, organizationId, notifyIntegratorDTO, options)(this.axios, this.basePath);
    }

    /**
     * Revoke roles from an organization user
     * @param {string} userId User id
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public revokeRoles(userId: string, organizationId: string, options?: any) {
        return OrganizationUsersApiFp(this.configuration).revokeRoles(userId, organizationId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrganizationUsersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Grant roles to an organization user
 * @param {string} userId User id
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function grantRoles(
    userId: string,
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationUsersApiAxiosParamCreator(configuration).grantRoles(userId, organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Send the API key and user id of an organization user to an integrator
 * @param {string} userId User id
 * @param {string} organizationId Organization id
 * @param {NotifyIntegratorDTO} notifyIntegratorDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function notifyIntegrator(
    userId: string,
    organizationId: string,
    notifyIntegratorDTO: NotifyIntegratorDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationUsersApiAxiosParamCreator(configuration).notifyIntegrator(userId, organizationId, notifyIntegratorDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Revoke roles from an organization user
 * @param {string} userId User id
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function revokeRoles(
    userId: string,
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationUserDTO> {
    const localVarAxiosArgs = OrganizationUsersApiAxiosParamCreator(configuration).revokeRoles(userId, organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

